export const MINIPRO_LIST_URL = '/mp/miniprogram';
export const MINIPRO_CONF_URL = '/mp/miniprogramconfig';
